<template>
  <h6 class="element-header">Gruppenmaßnahmen - {{ coaching.nameOfCoaching.operationTypeTranslated }}</h6>
  <div>
    <h5 class="form-header">Berichtsportale:</h5>
    <div class="row mb-3">
      <div class="col-12">
        <h6 class="form-header">Fortschritt</h6>
        <div class="progress">
          <div class="progress-bar" role="progressbar" aria-valuemax="100" aria-valuemin="0" aria-valuenow="25"
               :style="{ width: styleWidth }">
            {{ formattedUnitsDonePercent }}%
          </div>
        </div>
      </div>
    </div>

    <div class="row m-0 portal_user_data p-3" style="font-size: 15px">
      <div class="col-lg-6 col-md-12">
        <div class="row">
          <div class="col-sm-5 col-6 mb-1"><strong>Vorname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.firstName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Nachname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.lastName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>JC / AA Nummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.aaNumber || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Versicherungsnr:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{
              coaching?.unemployed?.insuranceNumber || 'Keine Angaben'
            }}
          </div>

          <div class="col-sm-5 col-6 mb-1"><strong>Email:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic text-break">{{
              coaching?.unemployed?.email || 'Keine Angaben'
            }}
          </div>

          <div class="col-sm-5 col-6 mb-1"><strong>Telefonnummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.phone || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Sachbearbeiter:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.coaching?.clerk || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Adresse:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">
            {{ coaching?.unemployed?.address }},
            {{ coaching?.unemployed?.zip }} {{ coaching?.unemployed?.city }}
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
        <div class="d-flex flex-wrap justify-content-lg-end justify-content-center">

          <div class="portal-export-item m-0 text-center" style="min-width: 110px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export portal-export-button w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/group-coaching/final-report-pdf/${coaching.id}`)">
              <img src="../../../../assets/img/pdf_icon_version4.png"
                   alt="PDF"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark fw-bold" style="line-height: 1.1;">
                Abschlussbericht
              </p>
            </a>
          </div>

          <div v-if="coaching.digitalSignature"
               class="portal-export-item text-center"
               style="min-width: 110px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export portal-export-button w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/group-coaching/meeting-list-pdf/${coaching.id}`,  undefined,  filtersFormated)">
              <img src="../../../../assets/img/pdf_icon_version4.png"
                   alt="PDF"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark fw-bold" style="line-height: 1.1;">
                Anwesenheitsliste
              </p>
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4 border-top pt-3">
        <div class="d-flex flex-column align-items-end">
          <div class="h5 mb-0">
            <strong>{{ coaching?.calculatedUnits?.unitsDone }}</strong> / {{ coaching?.calculatedUnits?.maxUnits }}
            Einheiten
          </div>
          <div v-if="coaching?.calculatedUnits?.unitsLeft < 3" class="text-danger fw-bold middle mt-1">
            Sie haben noch {{ coaching.calculatedUnits.unitsLeft.toFixed(2) }} offene Einheiten
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="row m-0 portal_user_data">-->
    <!--      <div class="col-lg-2 col-md-6 col-sm-6 mb-3">-->
    <!--        <span style="font-size: 16px;">Vorname:</span> <br/>-->
    <!--        <span style="font-size: 16px;">Nachname:</span> <br/>-->
    <!--        <span style="font-size: 16px;">JC / AA Nummer:</span> <br/>-->
    <!--        <span style="font-size: 16px;">Versicherungsnr:</span> <br/>-->
    <!--        <span style="font-size: 16px;">Email:</span> <br/>-->
    <!--        <span style="font-size: 16px;">Telefonnummer:</span> <br/>-->
    <!--        <span style="font-size: 16px;">Sachbearbeiter:</span> <br/>-->
    <!--        <span style="font-size: 16px;">Adresse:</span> <br/>-->
    <!--        <span style="font-size: 16px;">Ort:</span> <br/>-->
    <!--      </div>-->

    <!--      <div class="col-lg-4 col-md-6 col-sm-12 pl-xl-n5">-->
    <!--        <span style="font-size: 16px; font-style: italic;">{{ coaching?.unemployed?.firstName }}</span> <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">{{ coaching?.unemployed?.lastName }}</span> <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">-->
    <!--          {{ coaching?.unemployed?.aaNumber || 'Keine Angaben' }}-->
    <!--        </span>-->
    <!--        <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">-->
    <!--          {{ coaching?.unemployed?.insuranceNumber || 'Keine Angaben' }}-->
    <!--        </span>-->
    <!--        <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">-->
    <!--          {{ coaching?.unemployed?.email || 'Keine Angaben' }}-->
    <!--        </span>-->
    <!--        <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">-->
    <!--          {{ coaching?.unemployed?.phone || 'Keine Angaben' }}-->
    <!--        </span>-->
    <!--        <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">-->
    <!--          {{ coaching?.coaching?.clerk || 'Keine Angaben' }}-->
    <!--        </span>-->
    <!--        <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">-->
    <!--          {{ coaching?.unemployed?.address }}-->
    <!--        </span>-->
    <!--        <br/>-->
    <!--        <span style="font-size: 16px; font-style: italic;">-->
    <!--          {{ coaching?.unemployed?.zip }} {{ coaching?.unemployed?.city }}-->
    <!--        </span>-->
    <!--        <br/>-->
    <!--      </div>-->

    <!--      <div class="col-lg-6 col-md-12 col-sm-12">-->
    <!--        <div class="text-end">-->
    <!--          <div id="portalDocumentExport">-->
    <!--            <a target="_blank"-->
    <!--               class="btn portal_pdf_export"-->
    <!--               @click="downloadFile(`/portal/group-coaching/final-report-pdf/${coaching.id}`,-->
    <!--               undefined,  filtersFormated)">-->
    <!--              <img src="../../../../assets/img/pdf_icon_version4.png" alt=""/>-->
    <!--              <p>Abschlussbericht</p>-->
    <!--            </a>-->
    <!--          </div>-->
    <!--          <div id="portalDocumentExport" v-if="coaching.digitalSignature">-->
    <!--            <a target="_blank"-->
    <!--               class="btn portal_pdf_export"-->
    <!--               @click="downloadFile(`/portal/group-coaching/meeting-list-pdf/${coaching.id}`,-->
    <!--               undefined,  filtersFormated-->
    <!--               )">-->
    <!--              <img src="../../../../assets/img/pdf_icon_version4.png" alt=""/>-->
    <!--              <p>Anwesenheitsliste</p>-->
    <!--            </a>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col-12 text-end d-flex justify-content-end align-items-start">-->
    <!--        <div>-->
    <!--          <div style="display: inline; font-size: 18px;">{{ coaching?.calculatedUnits?.unitsDone }} /</div>-->
    <!--          <div style="display: inline; font-size: 18px;">{{ coaching?.calculatedUnits?.maxUnits }}</div>-->
    <!--          <div v-if="coaching?.calculatedUnits?.unitsLeft < 3"-->
    <!--               style="display: block; font-size: 15px; margin-top: 10px; color: red;">-->
    <!--            Sie haben {{ coaching.calculatedUnits.unitsLeft.toFixed(2) }} offene Einheiten-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script setup>
import {downloadFile} from '@/shared/functions';
import {computed, defineProps, onMounted, ref, toRefs, watch} from 'vue';

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  filtersFormated: {
    type: Object,
    required: false,
  },
});

const coaching = toRefs(props)['coaching'];
const unitsDonePercent = ref(0.0);

const styleWidth = computed(() => {
  if (unitsDonePercent.value === 0.0) {
    return '0%'; // Explicitly return "0%"
  } else if (unitsDonePercent.value < 1) {
    return '3%'; // Explicitly return "3%"
  } else {
    return unitsDonePercent.value + '%'; // Correct concatenation
  }
});

// Format the percentage value (2 decimal places)
const formattedUnitsDonePercent = computed(() => {
  return unitsDonePercent.value.toFixed(2).replace('.', ',');
});

watch(() => coaching.value.unitsDonePercent, (newVal) => {
  if (newVal !== null) {
    unitsDonePercent.value = +newVal;
  }
});

onMounted(() => { // Use onMounted to ensure props are available
  if (coaching.value && coaching.value.unitsDonePercent !== null) {
    unitsDonePercent.value = +coaching.value.unitsDonePercent;
  }
});
</script>

<style scoped>

</style>